export const skillData = [
  { label: "Yoga", value: "yoga" },
  { label: "Musical Instrument", value: "musical" },
  { label: "Acting", value: "acting" },
  { label: "Dancing", value: "dancing" },
  { label: "Body Building", value: "bodybuilding" },
  { label: "Singing", value: "singing" },
  { label: "Poetry", value: "poetry" },
];

export const subCatData = {
  yoga: [
    { label: "Hatha Yoga", value: "hatha" },
    { label: "Vinyasa Yoga", value: "vinyasa" },
    { label: "Ashtanga Yoga", value: "ashtanga" },
    { label: "Iyengar Yoga", value: "iyengar" },
    { label: "Bikram (Hot) Yoga", value: "bikram" },
  ],
  musical: [
    { label: "Violin", value: "violin" },
    { label: "Viola", value: "viola" },
    { label: "Cello", value: "cello" },
    { label: "Double Bass", value: "doublebass" },
    { label: "Guitar", value: "guitar" },
    { label: "Harp", value: "harp" },
    { label: "Ukulele", value: "ukulele" },
    { label: "Mandolin", value: "mandolin" },
    { label: "Flute", value: "flute" },
    { label: "Clarinet", value: "clarinet" },
    { label: "Oboe", value: "oboe" },
    { label: "Bassoon", value: "bassoon" },
    { label: "Saxophone", value: "saxophone" },
    { label: "Recorder", value: "recorder" },
    { label: "Piccolo", value: "piccolo" },
    { label: "English Horn", value: "englishhorn" },
    { label: "Trumpet", value: "trumpet" },
    { label: "Trombone", value: "trombone" },
    { label: "French Horn", value: "frenchhorn" },
    { label: "Tuba", value: "tuba" },
    { label: "Euphonium", value: "euphonium" },
    { label: "Cornet", value: "cornet" },
    { label: "Flugelhorn", value: "flugelhorn" },
    { label: "Drum Kit", value: "drumkit" },
    { label: "Congas & Bongos", value: "congasbongos" },
    { label: "Cajon", value: "cajon" },
    { label: "Xylophone", value: "xylophone" },
    { label: "Marimba", value: "marimba" },
    { label: "Timpani", value: "timpani" },
    { label: "Djembe", value: "djembe" },
    { label: "Tambourine", value: "tambourine" },
    { label: "Piano", value: "piano" },
    { label: "Digital Keyboard", value: "keyboard" },
    { label: "Organ", value: "organ" },
    { label: "Harpsichord", value: "harpsichord" },
    { label: "Accordion", value: "accordion" },
    { label: "Synthesizer", value: "synthesizer" },
    { label: "Theremin", value: "theremin" },
    { label: "Drum Machine", value: "drummachine" },
    { label: "Sampler", value: "sampler" },
    { label: "Electronic Drum Kit", value: "electronicdrumkit" },
    { label: "MIDI Controller", value: "midicontroller" },
    { label: "Turntable", value: "turntable" },
  ],
  acting: [
    { label: "Dramatic Monologue", value: "dramaticmonologue" },
    { label: "Comic Monologue", value: "comicmonologue" },
    { label: "Self‑taped Scene Study", value: "scenestudy" },
    { label: "Character Voice‑Over", value: "voiceover" },
    { label: "Narration/Commercial Read", value: "narration" },
    { label: "Physical Storytelling/Mime", value: "mime" },
    { label: "Musical Theatre", value: "musicaltheatre" },
    { label: "Solo Improv Response", value: "improv" },
  ],
  dancing: [
    { label: "Kathak", value: "kathak" },
    { label: "Bharatanatyam", value: "bharatanatyam" },
    { label: "Kuchipudi", value: "kuchipudi" },
    { label: "Odissi", value: "odissi" },
    { label: "Mohiniyattam", value: "mohiniyattam" },
    { label: "Manipuri", value: "manipuri" },
    { label: "Sattriya", value: "sattriya" },
    { label: "Bhangra", value: "bhangra" },
    { label: "Garba", value: "garba" },
    { label: "Ghoomar", value: "ghoomar" },
    { label: "Lavani", value: "lavani" },
    { label: "Bollywood Dance", value: "bollywood" },
    { label: "Contemporary Dance", value: "contemporary" },
    { label: "Hip Hop", value: "hiphop" },
    { label: "Ballet", value: "ballet" },
    { label: "Jazz", value: "jazz" },
    { label: "Tap", value: "tap" },
  ],
  bodybuilding: [
    { label: "Men’s Open Bodybuilding", value: "mensbodybuilding" },
    { label: "Men’s Physique", value: "mensphysique" },
    { label: "Classic Physique", value: "classicphysique" },
    { label: "Women’s Bodybuilding", value: "womensbodybuilding" },
    { label: "Women’s Figure", value: "womensfigure" },
    { label: "Women’s Bikini", value: "womensbikini" },
    { label: "Fitness Model", value: "fitnessmodel" },
    { label: "CrossFit", value: "crossfit" },
    { label: "Strongman", value: "strongman" },
    { label: "Powerlifting", value: "powerlifting" },
    { label: "Calisthenics", value: "calisthenics" },
  ],
  singing: [
    { label: "Hindustani Classical", value: "hindustani" },
    { label: "Carnatic Classical", value: "carnatic" },
    { label: "Bollywood/Film Singing", value: "bollywood" },
    { label: "Pop", value: "pop" },
    { label: "Rock", value: "rock" },
    { label: "Jazz", value: "jazz" },
    { label: "Western Classical", value: "westernclassical" },
    { label: "Folk", value: "folk" },
    { label: "Musical Theatre", value: "musicaltheatre" },
    { label: "A cappella", value: "acappella" },
  ],
  poetry: [
    { label: "Spoken Word", value: "spokenword" },
    { label: "Slam Poetry", value: "slampoetry" },
    { label: "Performance Poetry", value: "performancepoetry" },
    { label: "Dramatic Recitation", value: "dramaticrecitation" },
    { label: "Storytelling Poetry", value: "storytellingpoetry" },
    { label: "Haiku/Short‑Form Poetry", value: "haiku" },
    { label: "Narrative Poetry", value: "narrativepoetry" },
    { label: "Lyrical Poetry", value: "lyricalpoetry" },
    { label: "Beat Poetry", value: "beatpoetry" },
    { label: "Free Verse Reading", value: "freeverse" },
  ],
};